var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-textarea',_vm._b({attrs:{"value":_vm.localValue,"error-messages":_vm.localErrors},on:{"input":_vm.onInput}},'v-textarea',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }